<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="crt">Copyright © 2008 by The University Press of Kentucky</p>
<p class="crt">Scholarly publisher for the Commonwealth,<br/>serving Bellarmine University, Berea College, Centre College of Kentucky, Eastern Kentucky University, The Filson Historical Society, Georgetown College, Kentucky Historical Society, Kentucky State University, Morehead State University, Murray State University, Northern Kentucky University, Transylvania University, University of Kentucky, University of Louisville, and Western Kentucky University.<br/>All rights reserved.</p>
<p class="crt"><em>Editorial and Sales Offices:</em> The University Press of Kentucky 663 South Limestone Street, Lexington, Kentucky 40508-4008 <br/><a class="hlink" href="http://www.kentuckypress.com" target="_blank">www.kentuckypress.com</a></p>
<p class="crt">12 11 10 09 08   5 4 3 2 1</p>
<p class="crt">Library of Congress Cataloging-in-Publication Data</p>
<p class="crt">Black Greek-letter organizations in the twenty-first century: our fight has just begun / edited by Gregory S. Parks.<br/>   p. cm.<br/>  Includes bibliographical references and index.<br/>  ISBN 978-0-8131-2491-9 (hardcover: alk. paper)<br/>  1. Greek letter societies—United States. 2. African American college students—Societies, etc. I. Parks, Gregory, 1974-</p>
<table width="100%">
<tbody><tr><td>LJ34.B58 2008</td>
<td></td>
</tr>
<tr>
<td>378.1′98508996073—dc22</td>
<td>2007052578</td>
</tr>
</tbody></table>
<p class="crt">This book is printed on acid-free recycled paper meeting the requirements of the American National Standard for Permanence in Paper for Printed Library Materials.</p>
<p class="nonindent"><img alt="" src="OEBPS/images/9780813172958_logo2.png"/></p>
<p class="crt">Manufactured in the United States of America.</p>
<p class="nonindent"><img alt="" src="OEBPS/images/9780813172958_logo3.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780813172958_epub_cop_r1.vue?013acc33